export default "__VITE_ASSET__BowrGnGh__"